var _circle, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "united-kingdom-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#f0f0f0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1645",
    "data-name": "Group 1645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5267",
    "data-name": "Path 5267",
    d: "M3.721,7.041A17.934,17.934,0,0,0,.62,13.3H9.984Z",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5268",
    "data-name": "Path 5268",
    d: "M35.38,13.3a17.936,17.936,0,0,0-3.1-6.263L26.016,13.3Z",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5269",
    "data-name": "Path 5269",
    d: "M.62,22.7a17.936,17.936,0,0,0,3.1,6.263L9.984,22.7Z",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5270",
    "data-name": "Path 5270",
    d: "M28.959,3.721A17.935,17.935,0,0,0,22.7.62V9.984Z",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5271",
    "data-name": "Path 5271",
    d: "M7.041,32.279a17.936,17.936,0,0,0,6.263,3.1V26.016Z",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5272",
    "data-name": "Path 5272",
    d: "M13.3.62a17.936,17.936,0,0,0-6.263,3.1L13.3,9.984Z",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5273",
    "data-name": "Path 5273",
    d: "M22.7,35.38a17.936,17.936,0,0,0,6.263-3.1L22.7,26.016V35.38Z",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5274",
    "data-name": "Path 5274",
    d: "M26.016,22.7l6.263,6.263a17.935,17.935,0,0,0,3.1-6.263Z",
    fill: "#0052b4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1646",
    "data-name": "Group 1646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5275",
    "data-name": "Path 5275",
    d: "M35.848,15.652h-15.5V.152a18.165,18.165,0,0,0-4.7,0v15.5H.152a18.165,18.165,0,0,0,0,4.7h15.5v15.5a18.165,18.165,0,0,0,4.7,0v-15.5h15.5a18.165,18.165,0,0,0,0-4.7Z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5276",
    "data-name": "Path 5276",
    d: "M22.7,22.7h0l8.032,8.032q.554-.554,1.058-1.156L24.909,22.7H22.7Z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5277",
    "data-name": "Path 5277",
    d: "M13.3,22.7h0L5.272,30.728q.554.554,1.156,1.058L13.3,24.909V22.7Z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5278",
    "data-name": "Path 5278",
    d: "M13.3,13.3h0L5.272,5.272q-.554.554-1.058,1.156L11.091,13.3H13.3Z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5279",
    "data-name": "Path 5279",
    d: "M22.7,13.3h0l8.032-8.032q-.554-.554-1.156-1.058L22.7,11.091Z",
    fill: "#d80027"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEn);
export default __webpack_public_path__ + "static/media/ico_en.6d75492e5bb207cac5dc1324be7d052a.svg";
export { ForwardRef as ReactComponent };